import React, { Component } from 'react';
import { Switch, Route } from 'react-router-dom';

import NewChat from './new/NewChat';
import NewChatList from './new/NewChatList';

import AnalysedChat from './analysed/AnalysedChat';
import AnalysedChatList from './analysed/AnalysedChatList';

import ArchivedChat from './archived/ArchivedChat';
import ArchivedChatList from './archived/ArchivedChatList';

class ChatRoute extends Component {
  render() {
    return (
      <div className="chat">
        <Switch>
          <Route path="/chats/new/:chatId?" component={NewChatList} />
          <Route path="/chats/analysed/:chatId?" component={AnalysedChatList} />
          <Route path="/chats/archived/:chatId?" component={ArchivedChatList} />
        </Switch>
        <Switch>
          <Route path="/chats/new/:chatId" component={NewChat} />
          <Route path="/chats/analysed/:chatId" component={AnalysedChat} />
          <Route path="/chats/archived/:chatId" component={ArchivedChat} />
        </Switch>
      </div>
    );
  }
}

export default ChatRoute;
